import React from 'react';
import {
  Box,
  CardContent,
  CardMedia,
  Fade,
  Grid,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

import {
  DEFAULT_BORDER_RADIUS,
  DEFAULT_FADE_DELAY,
  DEFAULT_SHADOW,
  formBackground,
  FULL_HEIGHT,
  FULL_WIDTH,
} from '../utils/constants';

/**
 * Layout component to display a centered form with an image
 * @param {*} props
 * @returns
 */
function CenteredImageForm(props) {
  const img = props?.img ?? null;
  const title = props?.title ?? undefined;
  const children = props?.children ?? {};
  const hasBg = props?.bg ?? false;
  const theme = useTheme();

  const gridStyle = {
    height: FULL_HEIGHT,
    width: FULL_WIDTH,
    background: hasBg ? formBackground : theme.palette.white.main,
    border: '5px solid secondary',
  };

  const boxStyle = {
    maxHeight: FULL_HEIGHT,
    minHeight: '50vh',
    maxWidth: '50vw',
    background: theme.palette.white.main,
    borderRadius: DEFAULT_BORDER_RADIUS,
  };

  return (
    <Grid
      container
      spacing={0}
      alignItems="center"
      justifyContent="center"
      direction="row"
      sx={gridStyle}
    >
      <Fade in={true} sx={{ transitionDelay: DEFAULT_FADE_DELAY }}>
        <Box
          component={Grid}
          boxShadow={DEFAULT_SHADOW}
          container
          spacing={0}
          alignItems="center"
          justifyContent="space-evenly"
          style={boxStyle}
        >
          <Grid item xs={12} sm={10} md={8} lg={6}>
            <CardMedia component="img" image={img} />
          </Grid>
          <Grid item xs={12} sm={10} md={8} lg={6}>
            {title && <Typography variant="h2">{title}</Typography>}
            <CardContent>{children}</CardContent>
          </Grid>
        </Box>
      </Fade>
    </Grid>
  );
}

export default CenteredImageForm;
